import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler } from "../../app/SliceUtils";

export const fetchActivity = createAsyncThunk(
    '/api/activity/activityId',
    (activityId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/activity/${activityId}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchActivities = createAsyncThunk(
    '/api/activity/activities',
    (departmentId, { rejectWithValue }) => {
        const endpoint = departmentId !== null
            ? `api/activity/activities/${departmentId}`
            : `api/activity/activities`;
        return ApiFetch({ endpoint, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue);
    }
);

export const activitySlice = createSlice({
    name: 'activity',
    initialState: {
        activity: { data: null, status: null },
        activities: { data: null, status: null },
        scrollPosition: 0,
    },
    reducers: {
        setScrollPosition: (state, action) => {
            state.scrollPosition = action.payload;
        },
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchActivity, 'activity');
        CreateAsyncStatusHandler(builder, fetchActivities, 'activities');
    },
});

export const { setScrollPosition } = activitySlice.actions;

export default activitySlice.reducer;